/**
 * Sticky.
 * @param {Object} contain - elementSticky, pixelsToSticky, cssClass, activeScrollUp: Only for listener add class when scroll is up
 * @author Daniel Santos <daniel.santos@gradiweb.com>
 */

function listenerScrollEvent(elementSticky, cssClass, pixelsToSticky) {
  const scrollPixels = window.scrollY;

  if (scrollPixels >= pixelsToSticky) {
    elementSticky.classList.add(cssClass);
  } else {
    elementSticky.classList.remove(cssClass);
  }
}

function stickyElement(config) {
  const {
    elementSticky,
    pixelsToSticky,
    cssClass,
    activeScrollUp = false,
  } = config;

  if (elementSticky) {
    let previousScroll = pixelsToSticky;

    window.addEventListener('scroll', function (e) {
      if (activeScrollUp) {
        const scrollPixels = window.scrollY;

        if (scrollPixels < previousScroll) {
          elementSticky.classList.add(cssClass);
        } else if (scrollPixels > previousScroll) {
          elementSticky.classList.remove(cssClass);
        }

        if (scrollPixels < pixelsToSticky) {
          elementSticky.classList.remove(cssClass);
        }

        previousScroll = scrollPixels;
      } else {
        listenerScrollEvent(elementSticky, cssClass, pixelsToSticky);
      }
    });
  } else {
    window.removeEventListener('scroll', listenerScrollEvent);
  }
}

export { stickyElement };
